/**
 * Shared cart helpers used by the buy-options (product page) and PPF booking flows.
 * Wraps Shopify's Ajax Cart API (/cart/add.js, /cart/clear.js, /cart/update.js).
 */
(function (window) {
  async function request(url, options) {
    const res = await fetch(url, Object.assign({
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }, options));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const message = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
      throw new Error(message);
    }
    return data;
  }

  /**
   * items: [{ id: <variantId>, quantity: 1, properties: {...} }, ...]
   */
  function addItems(items) {
    return request('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: items })
    });
  }

  function clearCart() {
    return request('/cart/clear.js', { method: 'POST' });
  }

  function updateAttributes(attributes) {
    return request('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ attributes: attributes })
    });
  }

  /**
   * Empties the current cart, then adds the given items with optional cart-level attributes,
   * used by the PPF "Buy Now" flow so a booking is never mixed into an existing accessories cart.
   */
  async function replaceCartAndAdd(items, attributes) {
    await clearCart();
    if (attributes) await updateAttributes(attributes);
    return addItems(items);
  }

  window.CarzeloCart = { addItems, clearCart, updateAttributes, replaceCartAndAdd };
})(window);
